const handleRootPages = (rootPages, userRoles) =>
    rootPages.pages.filter((page) => userRoles.includes(page.meta.id));

const handleCategory = (
    current,
    categories,
    pagesByCategory,
    userRoles,
    pageComponents
) => {
    const parent = {...categories[current] };
    const children = pagesByCategory[current];

    if (!children) return null;

    parent.component = pageComponents[parent.component];

    parent.meta = {
        title: parent.name,
        requiresAuth: true,
        hiddenInNav: false,
        breadcrumbDisabled: true,
        childIds: children.roles,
        ...parent.meta,
    };

    parent.children = children.pages;

    if (userRoles.some((userRole) => children.roles.includes(userRole))) {
        return parent;
    }

    return null;
};

const groupPagesByCategory = (pages, pageComponents, userRoles, categories) =>
    pages.reduce((acc, current) => {
        if (!acc[current.category]) {
            acc[current.category] = {
                pages: [],
                roles: [],
            };
        }

        if (!userRoles.includes(current.roleFunction)) {
            return acc;
        }

        acc[current.category].pages.push({
            path: current.path,
            name: current.name,
            component: pageComponents[current.component],
            meta: {
                title: current.name,
                requiresAuth: true,
                hiddenInNav: false,
                breadcrumbDisabled: false,
                parent: categories[current.category] ?
                    categories[current.category].name :
                    "",
                id: current.roleFunction,
                ...current.meta,
            },
        });

        acc[current.category].roles.push(current.roleFunction);

        return acc;
    }, {});

const groupRoutesByName = (routes) =>
    routes.reduce((acc, current) => {
        if (current.name) {
            acc[current.name] = current;
        }

        return acc;
    }, {});

export const orderForNavigation = (routes, order) => {
    const routesByName = groupRoutesByName(routes);
    const routeNames = Object.keys(routesByName);
    const unorderedRoutes = routeNames
        .filter((routeName) => !order.includes(routeName))
        .map((pageName) => routesByName[pageName])
        .filter((page) => Boolean(page));
    const orderedRoutes = order
        .map((pageName) => routesByName[pageName])
        .filter((page) => Boolean(page));

    return [...orderedRoutes, ...unorderedRoutes];
};

export const getRoutes = (userRoles, pages, categories, pageComponents) => {
    const pagesByCategory = groupPagesByCategory(
        pages,
        pageComponents,
        userRoles,
        categories
    );

    const categoryKeys = Object.keys(categories);

    const routes = categoryKeys.reduce((acc, current) => {
        const category = handleCategory(
            current,
            categories,
            pagesByCategory,
            userRoles,
            pageComponents
        );

        if (category) {
            acc.push(category);
        }

        return acc;
    }, []);

    const rootPages = handleRootPages(pagesByCategory["root"], userRoles);

    return [...routes, ...rootPages];
};